{
	"language": {
		"select": "Pilih bahasa",
		"sectionTitle": "Bahasa",
		"changeSuccess": "Bahasa berhasil diubah"
	},
	"assistant": {
		"composer": {
			"placeholder": "Tanya {{assistantName}}",
			"disclaimer": "{{assistantName}} bisa membuat kesalahan. Periksa info penting."
		},
		"greeting": {
			"initialMessage": "👋 Hai, saya asisten belajar **{{assistantName}}**, dan saya di sini untuk membantu Anda mempersiapkan **{{context}}** dengan lebih baik! Mari kita bahas secara khusus soal yang Anda jawab tentang **{{topic}}.**",
			"starter": "Hai, saya **{{assistantName}}**. Ada yang bisa saya bantu?"
		},
		"chips": {
			"askYourOwn": "Ajukan pertanyaan Anda sendiri",
			"askFollowUp": "Ajukan pertanyaan lanjutan"
		},
		"emptyState": {
			"title": "{{assistantName}} adalah asisten belajar AI Anda",
			"contextSubtitle": "Tanyakan apa saja tentang {{context}}",
			"activateSubtitle": "{{assistantName}} akan aktif setelah Anda menjawab pertanyaan"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Belajar cepat",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Tetapkan tanggal ujian untuk mendapatkan rekomendasi yang lebih baik.",
					"examDateWithValue": "Tanggal tes: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Bisa lebih baik",
				"itsAwesome": "Luar biasa"
			},
			"title": "Belajar Anda sedang lancar!",
			"body": "Kami senang melihat semangat belajar Anda! Bagaimana pengalaman Anda menggunakan aplikasi sejauh ini? Bersediakah Anda membagikan pendapat melalui ulasan?",
			"cta": "Mungkin nanti"
		},
		"actions": {
			"studyWeak": "Fokus pada bagian lemah",
			"viewProgress": "Lihat progres Anda",
			"seeRank": "Lihat peringkat Anda",
			"seeRankings": "Lihat papan peringkat",
			"unlock": "Buka konten premium",
			"unlockTooltip": "Dapatkan akses ke fitur eksklusif dan materi belajar lanjutan dengan membuka konten premium",
			"startCustomSession": "Buat sesi kustom",
			"startCustomSessionTooltip": "Mulai sesi belajar kustom untuk berfokus pada bagian tertentu dalam pembelajaran Anda",
			"takeDiagnostic": "Ikuti tes diagnostik",
			"takeDiagnosticTooltip": "Ikuti tes diagnostik untuk menilai level Anda saat ini dan menyesuaikan rencana belajar Anda",
			"viewDiagnostic": "Lihat hasil diagnostik",
			"viewDiagnosticTooltip": "Lihat hasil diagnostik untuk mengetahui kelebihan dan bagian yang perlu ditingkatkan",
			"viewPodcasts": "Dengarkan podcast",
			"viewPodcastsTooltip": "Akses podcast edukasi untuk meningkatkan pengalaman belajar Anda",
			"upgradeToPremium": "Beralih ke premium",
			"upgradeToPremiumTooltip": "Beralih ke premium untuk mengakses semua konten dan fitur",
			"extendAccess": "Perpanjang akses",
			"extendAccessTooltip": "Perpanjang akses Anda ke konten dan fitur premium",
			"setExamDate": "Tetapkan tanggal tes",
			"setExamDateTooltip": "Tetapkan tanggal tes untuk memantau progres dan mempersiapkan diri menghadapi tes"
		},
		"exam": {
			"daysAgo_one": "{{count}} hari lalu",
			"daysAgo_other": "{{count}} hari lalu",
			"untilExam_one": "{{count}} hari menuju ujian",
			"untilExam_other": "{{count}} hari menuju ujian",
			"isToday": "Ujian berlangsung hari ini!"
		},
		"stats": {
			"mastery": "Penguasaan",
			"completed_one": "Item dijawab",
			"completed_other": "Item dijawab",
			"completedValue": "{{count}}",
			"xpEarned": "XP diperoleh",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Akurasi",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Perkiraan kemahiran {{skill, lowercase}} Anda adalah {{level, lowercase}}",
			"itemsAnsweredTooltip": "Jumlah total item yang telah Anda jawab sejauh ini",
			"responsesAnsweredTooltip": "Jumlah total jawaban yang telah Anda kirim sejauh ini",
			"examDateTooltip": "Ujian Anda pada {{date}}",
			"skillCta": {
				"diagnostic": "Diagnostik",
				"practice": "Berlatih"
			}
		},
		"menu": {
			"settings": "Pengaturan",
			"profile": "Profil"
		},
		"diagnostics": {
			"title": "Diagnostik",
			"free": "Gratis",
			"duration": "{{count}} {{item}} • {{minutes}} menit",
			"completed": "{{count}} {{item}} selesai",
			"start": "Mulai",
			"viewReport": "Lihat laporan",
			"resume": "Lanjutkan"
		},
		"practiceTests": {
			"title": "Latihan ujian",
			"sectionalTestsTitle": "Tes per bagian",
			"diagnosticAssessmentsTitle": "Penilaian diagnostik",
			"premiumChipTooltip": "Tes latihan lengkap premium untuk ujian {{examName}}",
			"freeChipTooltip": "{{label}} untuk ujian {{examName}}",
			"freeChipTooltipDefault": "Penilaian diagnostik gratis untuk ujian {{examName}}",
			"completedDescription_one": "{{count}} soal • {{date}}",
			"completedDescription_other": "{{count}} soal • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} soal • {{timeRemaining}} tersisa",
			"activeDescription_other": "{{attempted}}/{{count}} soal • {{timeRemaining}} tersisa",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} soal • {{timeRemaining}} tersisa • Dimulai pada: {{startedOn}} • Berakhir pada: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} soal • {{timeRemaining}} tersisa • Dimulai pada: {{startedOn}} • Berakhir pada: {{endsOn}}",
			"notStartedDescription_one": "{{count}} soal • {{duration}}",
			"notStartedDescription_other": "{{count}} soal • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} soal • {{duration}} • Berakhir pada: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} soal • {{duration}} • Berakhir pada: {{endsOn}}",
			"viewResultsCta": "Lihat hasil",
			"startCta": "Mulai",
			"chips": {
				"items_one": "{{count}} soal",
				"items_other": "{{count}} soal",
				"progress_one": "{{attempted}}/{{count}} soal",
				"progress_other": "{{attempted}}/{{count}} soal",
				"timeRemaining": "{{time}} tersisa",
				"startedOn": "Dimulai pada: {{date}}",
				"endsOn": "Berakhir pada: {{date}}",
				"timeLeft": "{{time}} tersisa"
			},
			"status": {
				"notStarted": {
					"label": "Belum dimulai",
					"section": "Tes latihan lengkap"
				},
				"inProgress": {
					"label": "Sedang dikerjakan",
					"section": "Sedang dikerjakan"
				},
				"completed": {
					"label": "Selesai",
					"section": "Selesai"
				},
				"legacyReports": {
					"label": "Laporan lama",
					"section": "Laporan lama"
				},
				"migratedReports": {
					"label": "Laporan yang dimigrasikan",
					"section": "Laporan yang dimigrasikan"
				}
			}
		},
		"skills": {
			"title": "Keterampilan",
			"unlockSubtitle": "Buka premium untuk berlatih",
			"startCta": "Berlatih",
			"freeItemsIncludedChip": "Item gratis disertakan",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} dari {{count, number}} item gratis dijawab",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} dari {{count, number}} item gratis dijawab",
			"progressCards": {
				"questionTypesTitle": "Kinerja berdasarkan jenis soal",
				"questionTypesSubtitle": "Skor Anda pada berbagai jenis soal {{skill}}",
				"proficiencyTitle": "Kinerja berdasarkan kemahiran",
				"proficiencySubtitle": "Progres Anda di berbagai level {{skill}}",
				"questionTypeCardSubtitle": "Progres berdasarkan level kemahiran",
				"bySkillTitle": "Kinerja berdasarkan keterampilan",
				"bySkillSubtitle": "Progres keseluruhan di berbagai keterampilan",
				"needsImprovementTitle": "Perlu ditingkatkan",
				"needsImprovementSubtitle": "Keterampilan yang perlu difokuskan berikutnya",
				"skillPerformanceTitle": "Kinerja {{skill}}",
				"skillPerformanceSubtitle": "Progres berdasarkan jenis soal dan kemahiran",
				"skillLevelSubtitle": "Progres Anda pada level keterampilan ini",
				"skillsPerformanceTitle": "Kinerja Keterampilan",
				"performanceByItemDifficulty": "Kinerja berdasarkan kemahiran soal",
				"performanceByItemDifficultyCaption_one": "Menampilkan akurasi Anda berdasarkan level kemahiran dari {{count}} soal yang dikerjakan",
				"performanceByItemDifficultyCaption_other": "Menampilkan akurasi Anda berdasarkan level kemahiran dari {{count}} soal yang dikerjakan",
				"questionTypePartSubtitle": "{{skill}} · Bagian {{part}}",
				"activityGoalTitle": "Aktivitas & Progres Target",
				"recentActivityTitle": "Aktivitas Terkini",
				"goalProgressTitle": "Progres Target",
				"goalProgressSubtitle": "Skor keseluruhan · 7 minggu terakhir",
				"goalProgressInsight": "Progres Anda meningkat secara konsisten. Skor Anda 14 poin di bawah target dan target mungkin tercapai dalam sekitar 3 minggu.",
				"goalProgressActualLabel": "Skor Anda",
				"goalProgressTargetLabel": "Target",
				"goalProgressTimeAxisLabel": "Waktu",
				"goalProgressScoreAxisLabel": "Progres Keseluruhan",
				"statusTitle": "Status Anda",
				"diagnosticsTitle": "Diagnostik",
				"diagnosticsReviewCta": "Tinjau",
				"strengthsFocusTitle": "Kelebihan & Area Fokus",
				"strengthsFocusSubtitle": "Bagian terkuat Anda dan jenis soal yang memerlukan lebih banyak latihan",
				"strengthsLabel": "Kelebihan",
				"focusAreasLabel": "Area Fokus",
				"recommendedNextStepLabel": "Langkah Berikutnya yang Disarankan",
				"recommendedNextStepCta": "Mulai",
				"practiceTestsViewMore": "Lihat semua {{count}} tes"
			},
			"proficiencySection": "Berlatih berdasarkan level kemahiran"
		},
		"recommendedTasks": {
			"sectionTitle": "Rekomendasi untuk Anda",
			"startSessionAction": "Latihan",
			"resumeAction": "Lanjutkan",
			"reviewResultsAction": "Tinjau hasil",
			"startTestAction": "Mulai tes",
			"activeTestBody": "Selesaikan penilaian yang sedang berlangsung",
			"completedTestBody": "Tinjau kinerja dan jawaban Anda",
			"diagnosticBody": "Ikuti {{label}} untuk mengenal format ujian",
			"diagnosticDefaultLabel": "diagnostik gratis",
			"practiceTestBody": "Ukur kesiapan ujian Anda dengan tes berbatas waktu.",
			"sectionalTestBody": "Ikuti tes terfokus untuk melatih keterampilan {{skills}} Anda.",
			"weakSkillTitle": "Perkuat {{skill}} Anda",
			"weakSkillBody": "Latihan {{questionType}}, lebih banyak pada yang belum Anda kuasai.",
			"strongSkillTitle": "Jaga {{skill}} tetap tajam",
			"strongSkillBody": "Anda sudah kuat di sini. Set {{questionType}} singkat membantu mempertahankannya.",
			"mixedSkillTitle": "Lengkapi {{skill}} Anda",
			"mixedSkillBody": "Set campuran dari {{questionTypes}}, lebih banyak pada yang Anda lewatkan.",
			"higherDifficultySkillTitle": "Naik ke {{proficiency}}",
			"higherDifficultySkillBody": "Anda sudah menguasai {{questionType}} di level ini. Ini selangkah lebih sulit.",
			"itemsChip_one": "{{count}} soal",
			"itemsChip_other": "{{count}} soal",
			"timeRemainingChip": "Sisa {{minutes}} menit",
			"timeRemainingChipCompact": "{{minutes}} menit"
		},
		"itemTypes": {
			"answeredLabel_one": "Item dijawab",
			"answeredLabel_other": "Item dijawab",
			"answeredAll": "Semua",
			"answeredPartial": "{{answered}} dari {{total}}",
			"cardSubtitleResponses_one": "{{count}} jawaban",
			"cardSubtitleResponses_other": "{{count}} jawaban",
			"responsesLabel_one": "Jawaban",
			"responsesLabel_other": "Jawaban",
			"cardSubtitleComplete": "Semua item dijawab",
			"cardSubtitlePartial": "{{attempted}} dari {{total}} item dijawab",
			"detail": {
				"skillLabel": "Keterampilan",
				"estimatedLevelLabel": "Perkiraan level"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} jawaban",
			"responseCount_other": "{{count, number}} jawaban"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} item latihan gratis disertakan",
			"freeContentBannerTitle_other": "{{count, number}} item latihan gratis disertakan",
			"freeContentBannerBody": "Berlatih menggunakan item {{skills}} kapan saja. Tingkatkan untuk membuka Study-Pack lengkap.",
			"freeContentBannerCta": "Mulai latihan gratis"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Lihat peringkat Anda dibandingkan pengguna lain"
		},
		"home": {
			"title": "Beranda"
		},
		"podcasts": {
			"description": "Dengarkan podcast ortopedi yang dipandu para ahli."
		},
		"more": {
			"title": "Pengaturan Lainnya"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Belum ada progres belajar",
			"subtitle": "Progres Anda akan ditampilkan di sini saat Anda belajar",
			"cta": "Belajar sekarang"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Kesalahan",
			"body": "Gagal membuat sesi, silakan coba lagi"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Mahir",
			"highIntermediate": "Menengah",
			"intermediate": "Menengah",
			"basic": "Dasar",
			"none": "Belum dijawab",
			"high": "Dikuasai",
			"medium": "Hampir dikuasai",
			"low": "Perlu ditingkatkan"
		}
	},
	"leaderboard": {
		"you": "Ini Anda",
		"periods": {
			"all_time": "Sepanjang waktu",
			"month": "Bulan ini",
			"week": "Minggu ini"
		},
		"scope": {
			"global": "Global",
			"friends": "Teman"
		},
		"friends": {
			"soon": "SEGERA",
			"comingSoonTitle": "Papan peringkat teman",
			"comingSoonBadge": "Segera hadir",
			"comingSoonDescription": "Bandingkan progres Anda dengan teman dan lihat siapa yang berada di puncak kelas."
		},
		"error": {
			"title": "Kesalahan koneksi",
			"description": "Papan peringkat tidak dapat dimuat. Periksa koneksi Anda dan coba lagi.",
			"tryAgain": "Coba lagi"
		},
		"empty": {
			"title": "Belum ada peringkat",
			"description": "Jadilah yang pertama belajar dan raih posisi teratas di papan peringkat.",
			"startLearning": "Mulai belajar"
		},
		"topPerformers": "Peringkat teratas",
		"yourPosition": "Posisi Anda",
		"rankings": "Peringkat",
		"rankingsRange": "Peringkat • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Raih XP untuk masuk peringkat!",
			"description": "Mulai sesi belajar untuk meraih poin pertama Anda dan masuk ke papan peringkat.",
			"cta": "Mulai sesi pertama Anda"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "ANDA",
		"podium": {
			"first": "Ke-1",
			"second": "Ke-2",
			"third": "Ke-3"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>untuk melewati #{{rank}}</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit> XP</unit> <rest>menuju podium</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Pelajaran",
			"searchPlaceholder": "Cari pelajaran",
			"count_one": "{{count}} Pelajaran",
			"count_other": "{{count}} Pelajaran",
			"sortModalTitle": "Urutkan pelajaran",
			"filterModalTitle": "Filter berdasarkan topik",
			"sort": {
				"popularity": "Popularitas",
				"popularityShort": "Populer",
				"topic": "Topik",
				"difficulty": "Tingkat kesulitan",
				"recent": "Baru diperbarui",
				"recentShort": "Diperbarui",
				"completed": "Selesai"
			},
			"chips": {
				"all": "Semua",
				"recent": "Baru diperbarui",
				"completed": "Selesai",
				"premium": "Premium",
				"topics": "Topik",
				"topicsCount_one": "{{count}} topik",
				"topicsCount_other": "{{count}} topik"
			},
			"chipTooltips": {
				"all": "Tampilkan semua pelajaran.",
				"recent": "Tampilkan pelajaran yang baru diperbarui.",
				"completed": "Tampilkan pelajaran yang selesai.",
				"premium": "Tampilkan pelajaran premium.",
				"topics": "Filter pelajaran berdasarkan topik."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "selesai",
				"topics": "topik"
			},
			"empty": {
				"searchTitle_one": "{{count}} pelajaran tersembunyi oleh pencarian",
				"searchTitle_other": "{{count}} pelajaran tersembunyi oleh pencarian",
				"searchSubtitle": "Coba kata kunci lain atau hapus pencarian Anda",
				"searchCta": "Hapus pencarian",
				"filtersTitle_one": "{{count}} pelajaran tersembunyi oleh filter",
				"filtersTitle_other": "{{count}} pelajaran tersembunyi oleh filter",
				"filtersSubtitle_one": "Hapus filter {{filters}} untuk melihat lebih banyak",
				"filtersSubtitle_other": "Hapus filter {{filters}} untuk melihat lebih banyak",
				"filtersCta": "Hapus semua filter",
				"noneTitle": "Pelajaran tidak ditemukan",
				"noneSubtitle": "Coba hapus filter atau mulai pencarian baru",
				"noneCta": "Atur ulang semua"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Buka pengaturan"
			},
			"continueLearning": {
				"title": "Lanjutkan belajar"
			},
			"suggested": {
				"title": "Disarankan untuk Anda"
			},
			"completed": {
				"title": "Selesai"
			},
			"all": {
				"title": "Semua pelajaran"
			},
			"emptyState": {
				"title": "Belum ada pelajaran",
				"subtitle": "Periksa kembali segera untuk pelajaran baru."
			},
			"card": {
				"resumeCta": "Lanjutkan",
				"progress": "{{value}}% selesai",
				"timeLeft_one": "{{count}} menit tersisa",
				"timeLeft_other": "{{count}} menit tersisa",
				"duration_one": "{{count}} menit",
				"duration_other": "{{count}} menit"
			}
		},
		"overview": {
			"header": {
				"title": "Ringkasan"
			},
			"startCta": "Mulai belajar",
			"objectives": {
				"title": "Tujuan pembelajaran"
			}
		},
		"detail": {
			"takeQuizCta": "Kerjakan kuis",
			"progress": {
				"label": "Progres modul"
			},
			"activities": {
				"title": "Aktivitas",
				"completedCount": "{{completed}} dari {{total}} selesai"
			},
			"artifact": {
				"completed": "Selesai",
				"locked": "Terkunci"
			}
		},
		"stats": {
			"insights": {
				"title": "Wawasan progres"
			},
			"overallProgress": {
				"title": "Progres keseluruhan",
				"completedCount_one": "{{completed}} dari {{count}} item selesai",
				"completedCount_other": "{{completed}} dari {{count}} item selesai"
			},
			"milestones": {
				"title": "Pencapaian modul"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Bagian {{number}} dari {{total}}"
			},
			"upNext": {
				"title": "Berikutnya"
			}
		}
	},
	"sessionConfig": {
		"title": "Sesi belajar kustom",
		"diagnostic": "Diagnostik",
		"skill": "Keterampilan",
		"Proficiency": "Kemahiran",
		"Question Type": "Jenis soal",
		"mastery": "Penguasaan",
		"sessionLength": "Durasi sesi",
		"itemsChip_one": "{{count}} item",
		"itemsChip_other": "{{count}} item",
		"durationEstimate": "{{minutes}} mnt",
		"durationRange": "{{min}}–{{max}} mnt",
		"noItemsTooltip": "Tidak ada soal yang cocok dengan filter saat ini",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Oke",
		"status": {
			"notAnswered": "Belum dijawab",
			"needsWork": "Perlu ditingkatkan"
		},
		"itemCount": "Anda akan menyelesaikan {{count}} soal dari {{topics}}",
		"start": "Mulai sesi",
		"configuringSession": "Menyiapkan sesi",
		"fetchingContent": "Mengambil konten",
		"preparingMaterials": "Menyiapkan materi",
		"almostThere": "Hampir selesai",
		"startingSession": "Memulai sesi",
		"playIcon": "play-outline",
		"infoText": "Anda akan menyelesaikan **{{numItems}}** {{itemCount}}. Waktunya sekitar **{{timeString}}**.",
		"customSummary": {
			"message": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dari {{topics}}.",
			"messageWithMastery": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dari {{topics}}, dengan fokus pada $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Pelajari $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dari {{topics}} di semua tingkat penguasaan.",
			"itemCount_one": "{{count}} soal",
			"itemCount_other": "{{count}} soal",
			"masteryLevelCount_one": "tingkat penguasaan",
			"masteryLevelCount_other": "tingkat penguasaan",
			"allTopics": "semua {{count}} topik",
			"more": "{{count}} lainnya",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Belajar Cepat",
			"recommended": "Disarankan",
			"custom": "Kustom",
			"selectHelper": "Ketuk sesi untuk memilihnya, lalu mulai saat Anda siap.",
			"emptyRecommended": "Belum ada sesi yang disarankan saat ini.",
			"summary": "Pelajari {{count}} soal dari {{skill}}. Perkiraan waktu {{minutes}} menit.",
			"summary_questionType": "Pelajari {{count}} soal dari {{skill}}, {{questionType}}. Perkiraan waktu {{minutes}} menit.",
			"duration": "{{minutes}} menit",
			"durationSelector": {
				"title": "Durasi"
			},
			"levelSessions": {
				"rapidRecall": "Ulasan kilat",
				"purposefulPractice": "Latihan terarah",
				"focusFlow": "Fokus mendalam",
				"itemsLabel": "Soal level {{level}}",
				"itemsLabelGeneric": "soal",
				"summaries": {
					"rapidRecall": "Pelajari sekilas {{count}} soal level {{level}} yang belum Anda jawab untuk memperluas cakupan secara bertahap. Perkiraan waktu {{minutes}} menit.",
					"purposefulPractice": "Kerjakan set seimbang berisi {{count}} soal level {{level}}, dimulai dari materi yang paling perlu ditingkatkan. Perkiraan waktu {{minutes}} menit.",
					"focusFlow": "Perkuat bagian lemah Anda dengan {{count}} soal level {{level}} yang telah Anda jawab dengan penguasaan rendah atau sedang. Perkiraan waktu {{minutes}} menit."
				},
				"summariesGeneric": {
					"rapidRecall": "Pelajari sekilas {{count}} soal yang belum Anda jawab untuk memperluas cakupan secara bertahap. Perkiraan waktu {{minutes}} menit.",
					"purposefulPractice": "Kerjakan set seimbang berisi {{count}} soal, dimulai dari materi yang paling perlu ditingkatkan. Perkiraan waktu {{minutes}} menit.",
					"focusFlow": "Perkuat bagian lemah Anda dengan {{count}} soal yang telah Anda jawab dengan penguasaan rendah atau sedang. Perkiraan waktu {{minutes}} menit."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Untuk mempersonalisasi pengalaman Anda, mulailah dengan kuis diagnostik. Hasil diagnostik Anda akan digunakan untuk membuat rencana belajar Anda."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Tingkatkan ke premium",
		"unlockTitle": "Buka pengalaman lengkap {{productName}} Anda",
		"unlockDescription": "Buka latihan personal yang dirancang berdasarkan sisa waktu belajar Anda.",
		"readyTitle": "Bersiaplah untuk ujian Anda pada {{date}}",
		"tip": "Fokus personal Anda: premium mengidentifikasi apa yang perlu dilatih berikutnya dan menyesuaikan rencana belajar Anda seiring kemajuan Anda."
	},
	"purchase": {
		"success": {
			"headerTitle": "Terima kasih atas pembelian Anda!",
			"accessGranted": "Akses ke {{name}} Anda telah berhasil diberikan",
			"studyPack": "Study-Pack",
			"practiceTest": "Tes Latihan",
			"combo": "Paket Kombinasi",
			"documentTitle": "Pembelian",
			"summary_one": "Selamat! **Produk** di bawah ini telah dibuka di akun Anda. Setelah menekan {{action}}, konteks aplikasi Anda akan diubah untuk menampilkan ujian: **{{examName}}**. Anda dapat mengubahnya kapan saja melalui pengaturan akun jika ingin belajar untuk ujian lain atau membeli langganan lain.",
			"summary_other": "Selamat! **{{count}} produk** di bawah ini telah dibuka di akun Anda. Setelah menekan {{action}}, konteks aplikasi Anda akan diubah untuk menampilkan ujian: **{{examName}}**. Anda dapat mengubahnya kapan saja melalui pengaturan akun jika ingin belajar untuk ujian lain atau membeli langganan lain.",
			"unlockedDuration": "Selamat! Anda telah membuka akses **{{duration}}** ke **{{name}}**. Akses ini berakhir pada **{{expiry}}**.",
			"storeNote": "Catatan: Study-Pack hanya dapat diakses melalui aplikasi seluler kami. Silakan unduh aplikasi yang sesuai dengan perangkat Anda.",
			"actions": {
				"goToHome": "Ke beranda",
				"startDiagnostic": "Mulai {{label}}",
				"takeDiagnostic": "Ikuti {{label}}",
				"takeFreeDiagnostic": "Ikuti diagnostik gratis",
				"diagnosticLabel": "diagnostik"
			}
		},
		"checkout": {
			"headerTitle": "Selesaikan Pembelian Anda"
		},
		"paywall": {
			"studyPackDialogTitle": "Tingkatkan paket belajar Anda",
			"defaultDialogTitle": "Tingkatkan paket belajar Anda",
			"practiceTestDialogTitle": "Buka akses tes latihan",
			"restorePurchaseDialogTitle": "Sudah membeli?",
			"restorePurchaseDialogSubheadingWeb": "Jika tidak, coba ini:",
			"restorePurchaseDialogBody": "Jika Anda sudah membeli produk ini tetapi masih terkunci, coba langkah berikut:\n\n1. Pastikan Anda masuk dengan akun yang benar\n2. Pastikan produk yang dipilih sudah benar\n3. Pastikan langganan Anda belum berakhir\n4. Pastikan Anda sudah mengaktifkan langganan (periksa folder spam)\n5. Jika Anda punya kode akses, [kode akses]({{baseUrl}}/redeem)\n\nJika tidak ada yang sesuai, **klik di sini**",
			"restorePurchaseDialogBodyWeb": "1. Pastikan Anda masuk dengan email yang benar\n2. Pastikan **[ujian yang dipilih](/account/settings)** sudah benar\n3. Pastikan langganan Anda belum berakhir\n\nJika tidak ada yang sesuai, **hubungi dukungan**",
			"accesDuration": {
				"yearPlan": "Paket **{{duration}}** memberikan akses lebih lama sehingga Anda dapat belajar dengan fleksibel sesuai ritme sendiri dan mempersiapkan tes secara menyeluruh.",
				"moreTime": "Jika merasa memerlukan lebih banyak waktu untuk belajar, Anda dapat mempertimbangkan paket **{{duration}}**.",
				"otherPlan": "Paket **{{duration}}** memberi Anda akses hingga **{{expiryText}}**, sehingga Anda memiliki cukup waktu untuk belajar. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Tingkatkan",
				"unlock": "Buka akses seharga {{price}}",
				"subscribe": "Berlangganan seharga {{price}}",
				"extendAccess": "Perpanjang akses",
				"accessHere": "Akses di sini",
				"redeemAccessCode": "Punya kode akses?",
				"restorePurchase": "Sudah membeli?",
				"restorePurchaseWeb": "Sudah membeli atau punya kode akses?"
			},
			"subscriptionSummary": {
				"yearly": "Langganan tahunan • Perpanjangan otomatis • Batalkan kapan saja",
				"monthly": "Langganan bulanan • Perpanjangan otomatis • Batalkan kapan saja",
				"weekly": "Langganan mingguan • Perpanjangan otomatis • Batalkan kapan saja",
				"generic": "Langganan dengan perpanjangan otomatis • Batalkan kapan saja"
			},
			"planDuration": {
				"day_one": "{{count}} hari",
				"day_other": "{{count}} hari",
				"week_one": "{{count}} minggu",
				"week_other": "{{count}} minggu",
				"month_one": "{{count}} bulan",
				"month_other": "{{count}} bulan",
				"year_one": "{{count}} tahun",
				"year_other": "{{count}} tahun"
			},
			"recommendedPlan": {
				"plan": "Kami merekomendasikan paket **{{duration}}** agar Anda dapat mempersiapkan diri sebaik mungkin untuk ujian pada **{{date}}**",
				"subscription": {
					"yearly": "Kami merekomendasikan **langganan tahunan** untuk akses berkelanjutan dan persiapan ujian Anda pada **{{date}}**",
					"monthly": "Kami merekomendasikan **langganan bulanan** untuk akses berkelanjutan dan persiapan ujian Anda pada **{{date}}**",
					"weekly": "Kami merekomendasikan **langganan mingguan** untuk akses berkelanjutan dan persiapan ujian Anda pada **{{date}}**",
					"generic": "Kami merekomendasikan **langganan** untuk akses berkelanjutan dan persiapan ujian Anda pada **{{date}}**"
				}
			},
			"disclaimer": "Setelah pembelian dikonfirmasi, Anda akan mendapatkan akses penuh ke konten produk ini selama durasi yang dipilih. Saat periode tersebut berakhir, Anda akan kehilangan akses ke konten terbatas. Jika Anda ingin memperpanjang akses karena alasan apa pun (misalnya Anda memindahkan tanggal ujian), Anda dapat menambah waktu melalui pembelian dalam aplikasi tambahan. Untuk informasi selengkapnya, lihat [Ketentuan Layanan dan Kebijakan Privasi](https://memorang.com/legal) kami."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Berdasarkan {{numItems}} {{item}} yang dicoba dalam {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Ini menunjukkan progres Anda dalam {{count}} {{type}}. Progres dihitung berdasarkan {{itemCount}} {{item}} yang telah Anda coba sejauh ini."
		},
		"needsImprovement": {
			"title": "Perlu ditingkatkan",
			"subtitle": "{{type}} yang disarankan untuk Anda tingkatkan",
			"cta": "Belajar sekarang"
		},
		"mastery": {
			"high": "Dikuasai",
			"medium": "Hampir tercapai",
			"low": "Perlu latihan",
			"count": "{{count}} {{item}} dicoba",
			"zeroTooltip": "Belum ada item {{label}} dari {{total}} item yang dicoba",
			"highTooltip": "Anda telah menguasai {{count}} dari {{total}} {{item}} yang dicoba",
			"mediumTooltip": "Anda sedang berkembang pada {{count}} dari {{total}} {{item}} yang dicoba",
			"lowTooltip": "Anda perlu lebih banyak latihan pada {{count}} dari {{total}} {{item}} yang dicoba"
		},
		"stats": {
			"completion": "Penyelesaian",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Anda telah menyelesaikan {{completed}} dari {{total}} {{item}}"
		},
		"exams": {
			"title": "Latihan ujian",
			"subtitle_one": "Berdasarkan {{count}} asesmen yang selesai",
			"subtitle_other": "Berdasarkan {{count}} asesmen yang selesai"
		},
		"summary": {
			"title": "Ringkasan belajar",
			"subtitle": "Berdasarkan {{count}} {{item}} yang dicoba",
			"tooltip": "Ringkasan ini menunjukkan tingkat penguasaan dan progres penyelesaian Anda dari total {{count}} {{item}}. Performa Anda diukur melalui sesi latihan, penilaian, dan aktivitas belajar.",
			"mastery": "Penguasaan",
			"quickStats": "Statistik singkat"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Kemahiran {{skill}}",
			"proficiencyCardTooltip": "Saat ini Anda berada di tingkat {{skill, lowercase}} {{level, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} jenis item",
			"itemTypesCardSubtitle_other": "{{count}} jenis item",
			"itemTypesCardTitle": "Item {{skill}}",
			"itemTypeLevelTooltip": "Saat ini Anda berada di tingkat {{skill, lowercase}} {{level, lowercase}} pada jenis soal “{{itemType}}”",
			"itemTypesFallbackTitle": "Jenis Item",
			"itemTypesEmptyTitle": "Jenis item tidak tersedia",
			"itemTypesEmptySubtitle": "Kami tidak dapat menemukan jenis item untuk keterampilan ini. Kembali ke Progres dan coba lagi.",
			"itemTypesEmptyCta": "Kembali ke Progres",
			"notAnswered": "Belum dijawab",
			"answeredSubtitle_one": "Berdasarkan {{count}} item yang dijawab",
			"answeredSubtitle_other": "Berdasarkan {{count}} item yang dijawab",
			"responsesSubtitle_one": "Berdasarkan {{count}} jawaban",
			"responsesSubtitle_other": "Berdasarkan {{count}} jawaban",
			"testsTakenSubtitle_one": "Berdasarkan {{count}} tes yang dikerjakan",
			"testsTakenSubtitle_other": "Berdasarkan {{count}} tes yang dikerjakan",
			"startFirstTest": {
				"title": "Ayo mulai",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} item",
				"guidance": {
					"diagnostic": "Mulai dengan tes diagnostik untuk mengetahui kekuatan Anda dan menyesuaikan rencana belajar.",
					"sectional": "Tes seksional berfokus pada satu bagian ujian, jadi Anda mendapat skor dalam sesi yang lebih singkat.",
					"fullMock": "Tes simulasi penuh meniru ujian asli dari awal sampai akhir dan memberi skor paling lengkap."
				}
			},
			"noScoresTitle": "Belum ada skor {{skill, lowercase}}",
			"noScoresSubtitle": "Kerjakan tes pertama Anda untuk melihat perkiraan skor dan rincian tugas.",
			"noScoresCta": "Mulai",
			"noScoresCardSubtitle": "Berdasarkan tes yang Anda kerjakan",
			"personalBestLabel": "Rekor pribadi Anda",
			"latestLabel": "Terbaru Anda",
			"examCountdown_one": "Ujian Anda {{count}} hari lagi",
			"examCountdown_other": "Ujian Anda {{count}} hari lagi",
			"greeting": {
				"none": "Mari mulai, {{firstName}}! 🚀",
				"low": "Awal yang bagus, {{firstName}} — lanjutkan! 💪",
				"medium": "Pertahankan, {{firstName}}! 💪",
				"high": "Sedikit lagi, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Mari mulai! 🚀",
				"low": "Awal yang bagus — lanjutkan! 💪",
				"medium": "Pertahankan! 💪",
				"high": "Sedikit lagi! 🎯"
			},
			"stats": {
				"untilExam": "Tanggal Ujian",
				"itemsAnswered": "Item Dijawab",
				"responsesAnswered": "Jawaban"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Kode akses salah",
		"incorrectPassword": "Kata sandi salah. Silakan coba lagi.",
		"passwordPlaceholder": "Masukkan kata sandi",
		"emailPlaceholder": "mis., dave@gmail.com",
		"verify": {
			"openEmail": "Buka email untuk melanjutkan",
			"signInCta": "Memverifikasi akun Anda...",
			"signUpCta": "Membuat akun Anda...",
			"contactSupport": "Tidak melihat emailnya? Periksa folder spam Anda atau",
			"contactSupportLink": "Hubungi kami",
			"resendMagicLink": "Kirim ulang tautan ajaib",
			"resendMagicLinkIn": "Kirim ulang tautan ajaib dalam {{time}}",
			"signInBody": "Sedikit lagi! Kami sedang memverifikasi data Anda agar dapat masuk dengan aman ke aplikasi {{appName}}.",
			"signUpBody": "Hampir selesai! Kami sedang memverifikasi data Anda untuk membuat akun aplikasi {{appName}} baru.",
			"magicLinkEmail": "Kami telah mengirim tautan ajaib ke **{{email}}**\nKlik tautan di email Anda untuk masuk dengan aman.",
			"magicLinkEmailExpiry": "Tautan ini kedaluwarsa dalam 10 menit",
			"confirmEmail": "Konfirmasi email Anda",
			"redirectingToApp": "Mengalihkan ke aplikasi {{appName}}...",
			"appNotOpen": "Aplikasi tidak terbuka? Klik tombol di bawah untuk membuka aplikasi terkait",
			"openApp": "Buka aplikasi {{appName}}",
			"installAppPrompt": "Jika tidak terjadi apa-apa, pastikan aplikasi {{appName}} sudah terinstal di perangkat Anda",
			"verifyAccountTitle": "Verifikasi akun Anda",
			"emailResent": "Tautan ajaib telah dikirim ke {{email}}\nSilakan periksa kotak masuk Anda, termasuk folder spam.",
			"verificationLinkExpired": "Tautan verifikasi kedaluwarsa",
			"verificationLinkExpiredBody": "Tautan verifikasi kedaluwarsa setelah 10 menit dan hanya dapat digunakan satu kali. \nAnda dapat meminta tautan baru dengan masuk kembali",
			"accountSetupTimeoutTitle": "Tidak dapat menyelesaikan proses masuk",
			"accountSetupTimeoutBody": "Penyiapan akun Anda memerlukan waktu lebih lama dari perkiraan. Silakan coba masuk kembali atau hubungi dukungan jika masalah ini berlanjut.",
			"loginAgain": "Masuk kembali",
			"contactSupportExpiredLink": "Jika masalah ini terus berlanjut, beri tahu kami",
			"successTitle": "Anda kini masuk di tab lain",
			"successBody": "Tutup tab ini atau lanjutkan dari sini",
			"successCtaLabel": "Lanjutkan di sini",
			"needHelpLabel": "Butuh bantuan?",
			"contactSupportButton": "Hubungi kami"
		},
		"contactSupportDialog": {
			"title": "Kesulitan masuk?",
			"body": "Silakan hubungi dukungan pelanggan kami jika Anda kesulitan masuk, atau coba lagi",
			"cta": "Email Kami"
		},
		"emailInstruction": {
			"default": "Jika Anda tidak menerima email, periksa folder sampah, spam, dan baru dihapus",
			"edu": "Jika Anda tidak menerima email, periksa folder sampah, spam, dan baru dihapus, atau hubungi administrator TI Anda"
		},
		"createSessionLoader": {
			"configuringSession": "Menyiapkan sesi",
			"analyzingMastery": "Menganalisis penguasaan",
			"loadingContent": "Memuat konten"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Kami harus memanggil Anda siapa?",
				"description": "Nama pengguna Anda muncul di papan peringkat publik, sedangkan nama Anda tetap privat.",
				"usernameLabel": "Nama pengguna",
				"firstNameLabel": "Nama depan",
				"lastNameLabel": "Nama belakang",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Avatar dibuat secara otomatis berdasarkan nama pengguna Anda.",
				"profileSaveFailed": "Kami tidak dapat menyimpan profil Anda. Silakan coba lagi."
			},
			"testDate": {
				"cta": "Lanjutkan"
			},
			"examDate": {
				"daysAway": "Kita punya waktu {{value}} hari. Kami akan segera memprioritaskan area terlemah Anda."
			},
			"skills": {
				"chooseAll": "Pilih semua yang sesuai"
			},
			"plan": {
				"recommended": "Disarankan"
			},
			"toeicLevelOverview": {
				"title": "Semua orang memulai dari suatu titik.",
				"description": "Latihan membantu Anda menguasai satu level sebelum berkembang secara alami ke level berikutnya.",
				"illustrationLabel": "Perkembangan dari Dasar (A1–A2) ke Menengah (B1–B2) hingga Mahir (C1).",
				"levels": {
					"basic": {
						"name": "Dasar",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Menengah",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Mahir",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Cara Anda berkembang",
					"practiceSessions": "Latih sesi yang direkomendasikan",
					"buildMastery": "Bangun penguasaan di level Anda saat ini",
					"growToward": "Terus berkembang menuju Mahir"
				},
				"levelDetails": {
					"title": "Arti setiap level",
					"scoreRange": "{{band}} · skor {{min}}–{{max}}",
					"basic": {
						"name": "Pengguna Dasar",
						"summary": "Bahasa Inggris sederhana di tempat kerja",
						"examples": {
							"forms": "Formulir & pemberitahuan",
							"instructions": "Instruksi",
							"announcements": "Pengumuman singkat"
						}
					},
					"intermediate": {
						"name": "Pengguna Menengah",
						"summary": "Komunikasi sehari-hari di tempat kerja",
						"examples": {
							"emails": "Email & percakapan",
							"customers": "Interaksi dengan pelanggan",
							"followUps": "Tindak lanjut rapat"
						}
					},
					"proficient": {
						"name": "Pengguna Mahir",
						"summary": "Bahasa Inggris profesional & tingkat lanjut",
						"examples": {
							"reports": "Laporan & presentasi kompleks",
							"negotiations": "Negosiasi bernuansa",
							"highStakes": "Konteks profesional berisiko tinggi"
						}
					}
				},
				"disclaimer": "Skor TOEIC Link adalah panduan yang selaras dengan CEFR, bukan batas nilai mutlak. Reading dan Listening berkembang secara independen — Anda dapat mencapai level berbeda di setiap keterampilan."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnostik: {{title}}",
					"body": "{{count}} item untuk menemukan fokus belajar Anda",
					"duration": "{{minutes}} menit"
				},
				"homeChoice": {
					"title": "Jelajahi sendiri",
					"body": "Belum siap memulai, saya ingin menjelajahi aplikasi dulu"
				}
			}
		},
		"common": {
			"changeLater": "Anda dapat mengubahnya nanti"
		},
		"actions": {
			"previous": "Sebelumnya",
			"finish": "Selesai",
			"start": "Mulai",
			"continue": "Lanjutkan",
			"stepIndicator": "Langkah {{step}} dari {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Tentang Anda"
		},
		"exam": {
			"title": "Tes Anda"
		},
		"subscriptions": {
			"title": "Produk",
			"redeem": {
				"title": "Tukarkan pembelian"
			},
			"extend": {
				"cta": "Perpanjang"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Tetapkan target tanggal tes Anda",
			"description": "Tanggal ini hanya untuk memandu jadwal belajar Anda di dalam aplikasi. Tanggal ini tidak memengaruhi pendaftaran tes resmi Anda.",
			"dismissCta": "Nanti saja",
			"confirmCta": "Tetapkan tanggal tes"
		}
	},
	"account": {
		"title": "Pengaturan akun",
		"currentExam": "Tes saat ini",
		"subscriptions": "Hak akses",
		"examDate": "Tanggal tes",
		"examDateUpdated": "Tanggal tes ditetapkan ke {{date}}",
		"selectDate": "Pilih tanggal",
		"appearance": "Tampilan",
		"features": "Fitur",
		"audioPlaybackTest": "Tampilkan dialog pemutaran audio tes",
		"theme": "Tema",
		"selectTheme": "Pilih tema",
		"themeOptions": {
			"system": "Sistem",
			"light": "Terang",
			"dark": "Gelap"
		},
		"accountInfo": "Akun",
		"username": "Nama pengguna",
		"name": "Nama",
		"nameNotSet": "Belum diatur",
		"save": "Simpan",
		"editUsername": {
			"title": "Edit nama pengguna"
		},
		"editName": {
			"title": "Edit nama"
		},
		"email": "Email",
		"dev": "Pengembangan",
		"sandbox": "Sandbox",
		"redoOnboarding": "Ulangi pengenalan",
		"about": "Tentang",
		"termsOfService": "Ketentuan layanan",
		"privacyPolicy": "Kebijakan privasi",
		"aiToolsTos": "Ketentuan penggunaan alat AI",
		"support": "Dukungan",
		"supportEmailBody": "Saya menghubungi Anda karena memerlukan bantuan terkait [  ]\n\n\n\nBerikut beberapa informasi yang dapat membantu menyelesaikan masalah lebih cepat: \n\nNama pengguna yang terkait dengan akun (dapat ditemukan di pengaturan setelah masuk ke aplikasi):\n{{username}}\n\nEmail yang terkait dengan pesanan saya (dapat ditemukan di pengaturan setelah masuk ke aplikasi):\n{{email}}\n\nNomor Pesanan (biasanya tercantum dalam email tanda terima yang dikirim setelah pembelian):\n\nApakah mungkin nama atau email lain digunakan saat produk dibeli? Jika ya, mohon berikan informasinya:\n\nNama depan dan belakang:\n\nEmail:",
		"contactSupport": "Hubungi dukungan",
		"signOut": "Keluar",
		"signOutConfirmation": "Anda yakin ingin keluar?",
		"deleteAccount": "Hapus akun",
		"platform": "Platform",
		"partnerships": "Kemitraan",
		"validUntil": "Berakhir pada {{date}}",
		"extendValidity": "Perpanjang akses",
		"redeemPurchase": "Tukarkan pembelian",
		"redeemPurchaseNoneFound": "Tidak ada pembelian yang dapat ditukarkan",
		"redeemPurchaseCheckFailed": "Tidak dapat memeriksa pembelian. Silakan coba lagi.",
		"purchases": "Pembelian",
		"frequentlyAskedQuestions": "Pertanyaan yang sering diajukan",
		"deleteFeedbackForm": {
			"placeholder": "Masukan"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Perlu lebih banyak data",
		"proficiencyLevelPendingTooltip": "Jawab lebih banyak item {{label}} untuk memperkirakan level Anda",
		"on": "aktif",
		"gotIt": "Mengerti",
		"goBack": "Kembali",
		"topic": "topik",
		"itemCount_one": "{{count}} item",
		"itemCount_other": "{{count}} item",
		"examCount_one": "{{count}} ujian",
		"examCount_other": "{{count}} ujian",
		"questionCount_one": "{{count}} soal",
		"questionCount_other": "{{count}} soal",
		"item_one": "item",
		"item_other": "item",
		"and": "dan",
		"this": "ini",
		"of": "dari",
		"knowMore": "Pelajari lebih lanjut",
		"proficiency": "kemahiran",
		"didNotAnswer": "Item yang belum Anda coba",
		"notAnswered": "Belum dijawab",
		"attempted": "dicoba",
		"attempt": "percobaan",
		"activity": "aktivitas",
		"performance": "Performa",
		"estimatedProficiency": "Perkiraan kemahiran",
		"details": "detail",
		"keepPracticing": "teruslah berlatih!",
		"leaveFeedback": "Berikan masukan",
		"copiedToClipboard": "Disalin ke papan klip",
		"eg": "mis.",
		"set": "set",
		"hint": "petunjuk",
		"itemType": "jenis item",
		"minute": "menit",
		"minutes": "{{count}} menit",
		"hour": "jam",
		"hours": "{{count}} jam",
		"continue": "Lanjutkan",
		"unlock": "Buka akses",
		"cancel": "Batal",
		"view": "Lihat",
		"switch": "Ganti",
		"update": "Perbarui",
		"ok": "Oke",
		"yes": "Ya",
		"free": "Gratis",
		"answered": "Dijawab",
		"correct": "Benar",
		"incorrect": "Salah",
		"marked": "Ditandai",
		"unmarked": "Tidak ditandai",
		"skipped": "Dilewati",
		"skill_one": "keterampilan",
		"skill_other": "keterampilan",
		"word_one": "kata",
		"word_other": "kata",
		"submitResponse": "Kirim jawaban",
		"viewDetails": "Lihat detail",
		"sec_one": "dtk",
		"sec_other": "dtk",
		"point_one": "poin",
		"point_other": "poin",
		"week": "Minggu",
		"month": "Bulan",
		"year": "Tahun",
		"day": "Hari",
		"selectTestDate": "Pilih tanggal tes",
		"points": "Poin",
		"viewAll": "Lihat semua",
		"timeline": "Linimasa",
		"save": "Simpan",
		"filters": {
			"selectAll": "Pilih semua",
			"deselectAll": "Batalkan semua pilihan",
			"selectedCount": "{{count}} dipilih",
			"expandSection": "Buka {{section}}",
			"collapseSection": "Tutup {{section}}"
		},
		"showMore": "Tampilkan lebih banyak",
		"showLess": "Tampilkan lebih sedikit",
		"expandA11yLabel": "Perluas deskripsi",
		"collapseA11yLabel": "Ciutkan deskripsi",
		"done": "Selesai",
		"clearAll": "Hapus semua",
		"clear": "Hapus",
		"datePicker": {
			"title": "Pilih tanggal",
			"enterDateLabel": "Masukkan tanggal",
			"enterDateRangeLabel": "Masukkan tanggal",
			"dateLabel": "Tanggal",
			"startDateLabel": "Tanggal mulai",
			"endDateLabel": "Tanggal selesai",
			"dateRequiredError": "Tanggal wajib diisi",
			"invalidDateFormatError": "Format tanggal tidak valid. Gunakan MM/DD/YYYY",
			"startAfterEndError": "Tanggal mulai tidak boleh setelah tanggal selesai",
			"endBeforeStartError": "Tanggal selesai tidak boleh sebelum tanggal mulai",
			"minDateError": "Tanggal harus {{date}} atau setelahnya",
			"maxDateError": "Tanggal harus {{date}} atau sebelumnya",
			"dateRangeError": "Tanggal harus antara {{startDate}} dan {{endDate}}",
			"setDateCta": "Tetapkan tanggal",
			"nextCta": "Berikutnya",
			"setTimeCta": "Tetapkan waktu"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} pelajar memilih jawaban ini.",
		"choiceCorrectA11yLabel": "Jawaban benar",
		"choiceIncorrectA11yLabel": "Jawaban salah",
		"choiceNotSelectedA11yLabel": "Tidak dipilih",
		"moreItemsAlertDialog": {
			"title": "Item Tambahan",
			"cta": "Mengerti"
		},
		"results": {
			"followUps": {
				"title": "Tindak Lanjut"
			},
			"summary": {
				"sessionAnalysis": "Analisis Sesi",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} item",
				"skilledItemCount_one": "{{count}} item {{skills}}",
				"skilledItemCount_other": "{{count}} item {{skills}}",
				"levelPhrase_one": "dari tingkat {{levels}}",
				"levelPhrase_other": "dari tingkat {{levels}}",
				"message": "<bold>Kerja bagus!</bold> Anda baru saja menyelesaikan {{itemPhrase}} dalam {{timeTaken}}.",
				"messageWithLevels": "<bold>Kerja bagus!</bold> Anda baru saja menyelesaikan {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) dalam {{timeTaken}}.",
				"proficiencyEstimateReady": "Perkiraan tingkat {{skill}} Anda adalah <bold>{{currentLevel}}</bold>. Kini Anda siap menargetkan <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Perkiraan tingkat {{skill}} Anda adalah <bold>{{currentLevel}}</bold>. Teruslah berlatih sebelum melanjutkan ke <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Perkiraan tingkat {{skill}} Anda adalah <bold>{{currentLevel}}</bold>. Luar biasa!",
				"mixedLevel": "Campuran",
				"overallScore": "Skor Keseluruhan",
				"stats": {
					"itemsAttempted_one": "Item dikerjakan",
					"itemsAttempted_other": "Item dikerjakan",
					"pointsEarned_one": "Poin diperoleh",
					"pointsEarned_other": "Poin diperoleh",
					"answeredCorrectly": "Dijawab dengan benar",
					"timeTaken": "Waktu yang Diperlukan",
					"target": "Target",
					"ofTotal": "dari {{total}}",
					"ofPointsTotal": "dari {{total}}",
					"skill": "Keterampilan",
					"skills": "Keterampilan",
					"questionType": "Jenis Soal",
					"questionTypes": "Jenis Soal",
					"proficiencyLevel": "Tingkat Kemahiran",
					"proficiencyLevels": "Tingkat Kemahiran"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Audio dimulai dalam {{seconds}} dtk",
			"audioStartsInPlayOnce": "Audio dimulai dalam {{seconds}} dtk, hanya diputar sekali",
			"videoStartsIn": "Video dimulai dalam {{seconds}} dtk",
			"videoStartsInPlayOnce": "Video dimulai dalam {{seconds}} dtk, hanya diputar sekali",
			"recordingIn": "Perekaman dimulai dalam {{seconds}} dtk"
		},
		"timeOverrunBanner": {
			"message": "Waktu habis. Dalam ujian sebenarnya, apa pun setelah ini tidak akan dinilai. Anda dapat terus berlatih."
		},
		"attributes": {
			"stimulus": "stimulus"
		},
		"stimulusTypes": {
			"reading": "Membaca",
			"listening": "Menyimak",
			"speaking": "Berbicara",
			"writing": "Menulis",
			"image": "Gambar"
		},
		"masteryLevels": {
			"belowBasic": "Di Bawah Dasar",
			"basic": "Dasar",
			"belowLowIntermediate": "Di Bawah Menengah Rendah",
			"lowIntermediate": "Menengah Rendah",
			"highIntermediate": "Menengah Tinggi",
			"advanced": "Mahir",
			"proficiencySubtitle": "Pada {{trademark}}, tingkat ini setara dengan skor **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Info bagian {{skill}}",
			"infoSectionText": {
				"Reading": "Bagian Membaca {{trademark}} menilai seberapa baik Anda dapat membaca dan memahami materi tertulis yang digunakan dalam lingkungan akademik. Bagian ini mencakup dua bacaan, masing-masing sepanjang sekitar 700 kata, dengan 10 soal per bacaan. Bagian Membaca membutuhkan waktu sekitar 35 menit untuk diselesaikan.",
				"Listening": "Bagian Menyimak {{trademark}} dirancang untuk mengukur kemampuan Anda dalam memahami percakapan dan kuliah berbahasa Inggris. Bagian ini mencakup kemampuan menyimak untuk: pemahaman dasar, memahami sikap dan tingkat keyakinan pembicara, serta menghubungkan informasi. Bagian Menyimak membutuhkan waktu sekitar 36 menit untuk diselesaikan.",
				"Speaking": "Bagian Berbicara {{trademark}} mengukur kemampuan Anda berbicara bahasa Inggris secara efektif dalam lingkungan akademik. Keempat soal/tugas menyerupai situasi nyata yang mungkin Anda temui baik di dalam maupun di luar kelas. Bagian Berbicara membutuhkan waktu sekitar 16 menit untuk diselesaikan.",
				"Writing": "Bagian Menulis pada tes {{trademark}} mengukur kemampuan Anda menulis dalam bahasa Inggris di lingkungan akademik dan menyampaikan gagasan secara jelas dan teratur. Anda akan mengetik jawaban menggunakan papan ketik komputer dan bagian Menulis membutuhkan waktu sekitar 29 menit untuk diselesaikan."
			}
		},
		"itemTypes": {
			"MCSS": "Pilihan ganda dengan satu jawaban",
			"MCSSH": "Pilihan ganda dengan satu jawaban yang disorot",
			"MCMS": "Pilihan ganda dengan beberapa jawaban",
			"MCMSH": "Pilihan ganda dengan beberapa jawaban yang disorot",
			"INSERT_TEXT": "Sisipkan teks",
			"MATCH_MS": "Pencocokan dengan beberapa pilihan",
			"MCSSM": "Pilihan ganda dengan satu jawaban untuk pencocokan",
			"MCMSM": "Pilihan ganda dengan beberapa jawaban untuk pencocokan",
			"MCGS": "Pilihan ganda untuk mengisi bagian rumpang",
			"MCOS": "Pilihan ganda untuk mengurutkan",
			"LISTENING_REPLAY": "Putar ulang simakan",
			"AUDIO_INPUT": "Input audio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Tanggapan diskusi akademik",
			"INTEGRATED_WRITING_RESPONSE": "Tanggapan menulis terpadu"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} dari {{total}}",
			"questionOfTotal": "Pertanyaan {{current}} dari {{total}}",
			"stimulusCorrespondsToNextItems": "Stimulus berikut berkaitan dengan {{total}} item selanjutnya",
			"passage": "Bacaan",
			"lecture": "Kuliah",
			"professorsQuestion": "Pertanyaan Profesor",
			"listen": "Dengarkan",
			"openPassage": "Buka bacaan",
			"backToItem": "Kembali ke item",
			"notYetInserted": "Belum disisipkan",
			"insertedAtPosition": "Disisipkan pada posisi #{{position}}"
		},
		"hint": {
			"show": "Tampilkan petunjuk"
		},
		"navigation": {
			"next": "Berikutnya",
			"exit": "Keluar",
			"saveAndExit": "Simpan & keluar",
			"previous": "Sebelumnya",
			"skip": "Lewati",
			"finish": "Selesai",
			"help": "Bantuan",
			"about": "Tips soal",
			"questionsButtonLabel": "Navigasi soal",
			"questionsButtonTooltip": "Buka soal mana pun atau tinjau soal yang ditandai",
			"questionsButtonActiveFiltersA11y": "Filter aktif: {{count}}",
			"recordingInProgressTooltip": "Anda tidak dapat meninggalkan item ini saat perekaman sedang berlangsung",
			"questionNotReachedTooltip": "Anda belum mencapai pertanyaan ini"
		},
		"questionTips": {
			"hideFutureLabel": "Jangan tampilkan tips secara otomatis"
		},
		"toolbar": {
			"calculatorTooltip": "Buka kalkulator",
			"highlightTooltip": "Pilih teks untuk menyorot informasi penting agar mudah dirujuk",
			"markTooltip": "Tandai soal ini untuk ditinjau kembali sebelum dikirim",
			"unmarkTooltip": "Klik untuk menghapus tanda pada soal ini"
		},
		"summary": {
			"viewFullInsights": "Lihat wawasan lengkap",
			"targetTooltip": "Target performa untuk sesi ini."
		},
		"stats": {
			"skill": "Keterampilan",
			"answered": "Dijawab",
			"speed": "Kecepatan",
			"duration": "Durasi",
			"duration_tooltip": "Panjang rekaman jawaban Anda: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Keyakinan",
			"pointsEarned": "Poin",
			"word": "Kata",
			"words": "Kata",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Anda memerlukan {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) untuk membaca dan menjawab item ini",
			"skill_tooltip": "Area keterampilan yang dinilai dalam item ini: {{skill}}",
			"answered_correct_tooltip": "Jawaban yang Anda kirim benar",
			"answered_incorrect_tooltip": "Jawaban yang Anda kirim salah",
			"skipped_tooltip": "Anda tidak mengirim jawaban untuk item ini",
			"words_tooltip": "Jumlah kata dalam jawaban tertulis Anda: {{count}}",
			"word_tooltip": "Jumlah kata dalam jawaban tertulis Anda: {{count}}",
			"confidence_tooltip": "Seberapa yakin Anda saat mengirim jawaban",
			"points_earned_tooltip_one": "Anda memperoleh {{points}} poin dari maksimum {{maximumScore}} poin untuk item ini",
			"points_earned_tooltip_other": "Anda memperoleh {{points}} poin dari maksimum {{maximumScore}} poin untuk item ini",
			"challengers_tooltip": "Jumlah peserta yang mengerjakan item ini sebelum Anda: {{count}}",
			"learning_mode_points_tooltip": "Poin yang diperoleh untuk percobaan ini: +{{xp}} XP",
			"pts_earned_tooltip": "Poin yang diperoleh untuk percobaan ini: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Tampilkan perincian"
		},
		"explanation": {
			"title": "Penjelasan",
			"feedback": "Umpan Balik",
			"skippedFeedbackNotice": "Anda melewati soal ini, sehingga masukan yang dipersonalisasi tidak dibuat."
		},
		"followUps": "Tindak Lanjut",
		"suggestCorrection": "Sarankan koreksi",
		"answer": {
			"correct": "Benar",
			"incorrect": "Salah",
			"skipped": "Dilewati"
		},
		"confidence": {
			"high": "Tinggi",
			"medium": "Sedang",
			"low": "Rendah"
		},
		"endDialog": {
			"title": "Akhiri sesi lebih awal?",
			"confirmEndDiagnostic": "Yakin ingin mengakhiri sesi? Semua progres akan hilang dan Anda harus memulai dari awal.",
			"confirmEnd": "Masih ada {{num}} {{itemLabel}}. Anda dapat menyelesaikannya sekarang atau terus belajar untuk menuntaskannya.",
			"confirmEndNoAnswer": "Anda belum menjawab satu soal pun. Yakin ingin selesai sekarang?",
			"confirmEndNoAnswerPositive": "Lanjut belajar",
			"confirmEndNoAnswerNegative": "Selesai sekarang"
		},
		"permissionDialog": {
			"title": "Perlu akses mikrofon",
			"descriptionWeb": "Latihan berbicara menggunakan mikrofon Anda. Browser Anda memblokir akses untuk situs ini — klik ikon izin di samping alamat web, izinkan mikrofon, lalu coba lagi.",
			"descriptionMobile": "Latihan berbicara menggunakan mikrofon Anda. Izinkan akses mikrofon di pengaturan perangkat Anda untuk melanjutkan.",
			"promptDescriptionWeb": "Latihan berbicara menggunakan mikrofon Anda. Minta izin lalu pilih Izinkan saat browser meminta.",
			"blockedDescriptionWeb": "Akses mikrofon diblokir untuk situs ini. Klik ikon di samping alamat web, izinkan mikrofon, lalu minta izin lagi.",
			"ok": "Oke",
			"cancel": "Batal",
			"openSettings": "Buka pengaturan",
			"requestPermission": "Minta izin",
			"dismissAndExit": "Tutup & keluar",
			"learnMore": "Pelajari lebih lanjut"
		},
		"audioPlaybackTestDialog": {
			"title": "Uji pemutaran audio",
			"description": "Aplikasi {{appName}} memiliki berbagai fitur pemutaran audio, seperti pada stimulus, item tes, dan pembaca teks. Untuk memastikan pengalaman terbaik, uji audio Anda di bawah ini. Setelah dipastikan berfungsi, lanjutkan.",
			"troubleshooting": {
				"title": "Pemecahan masalah audio",
				"volumeTitle": "Periksa volume perangkat",
				"volumeDescriptionWeb": "Sesuaikan volume menggunakan kontrol papan ketik atau pengaturan volume sistem di menu/bilah tugas",
				"volumeDescriptionMobile": "Gunakan tombol volume perangkat atau sesuaikan melalui pengaturan sistem",
				"outputTitle": "Periksa perangkat output audio",
				"outputDescription": "Jika menggunakan headphone, pastikan terhubung dengan benar dan dipilih sebagai perangkat output aktif",
				"browserTitle": "Periksa audio tab peramban",
				"browserDescription": "Cari ikon speaker dibisukan di samping judul tab dan aktifkan suaranya jika ada."
			},
			"skipCheck": "Lewati pemeriksaan ini lain kali",
			"workingButton": "Konfirmasi audio",
			"textToHear": "Anda seharusnya mendengar: {{text}}"
		},
		"overall": "Keseluruhan",
		"subskills": {
			"content": {
				"title": "Isi"
			},
			"languageUse": {
				"title": "Penggunaan Bahasa"
			},
			"organizationAndDevelopment": {
				"title": "Organisasi dan Pengembangan"
			},
			"topicDevelopment": {
				"title": "Pengembangan Topik"
			},
			"delivery": {
				"title": "Penyampaian"
			}
		},
		"finalizing": {
			"title": "Menyelesaikan hasil Anda",
			"gradingProgress": "Menilai jawaban..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Tugas berbicara di mana peserta mengulangi kalimat yang didengar seakurat mungkin.",
			"Read Aloud": "Soal berbicara di mana peserta membaca sebuah teks dengan suara keras untuk dinilai.",
			"Describe Image": "Tugas berbicara di mana peserta mendeskripsikan gambar secara detail.",
			"Write Essay": "Tugas jawaban tertulis yang mengharuskan esai terstruktur tentang topik yang diberikan.",
			"Retell Lecture": "Tugas berbicara di mana peserta merangkum ceramah atau presentasi yang telah didengarkan.",
			"Summarize Group Discussion": "Tugas menyimak di mana peserta merangkum diskusi dengan beberapa pembicara.",
			"Answer Short Question": "Tugas berbicara singkat berupa menjawab satu pertanyaan pendek dengan jawaban ringkas.",
			"Respond to a Situation": "Tugas berbicara di mana peserta merespons dengan tepat terhadap situasi yang dijelaskan.",
			"Summarize Written Text": "Tugas membaca di mana peserta merangkum sebuah teks dengan kata-kata sendiri.",
			"Reorder Paragraph": "Tugas membaca di mana peserta menyusun paragraf yang teracak ke urutan yang benar.",
			"Fill in the Blanks (Dropdown)": "Tugas membaca di mana setiap bagian kosong diisi dari menu pilihan dropdown.",
			"Fill in the Blanks (Type In)": "Tugas menyimak di mana peserta mengetik kata atau frasa pendek yang hilang.",
			"Fill in the Blanks (Drag and Drop)": "Tugas membaca di mana kata yang hilang diisi dengan menyeret pilihan ke bagian kosong.",
			"Multiple Choice, Single Answer": "Soal pilihan ganda di mana peserta memilih satu jawaban yang benar.",
			"Multiple Choice, Single Answer (Reading)": "Soal pilihan ganda membaca di mana peserta memilih satu jawaban yang benar.",
			"Multiple Choice, Single Answer (Listening)": "Soal pilihan ganda menyimak di mana peserta memilih satu jawaban yang benar.",
			"Multiple Choice, Multiple Answers": "Soal di mana peserta dapat memilih lebih dari satu jawaban yang benar.",
			"Multiple Choice, Multiple Answers (Reading)": "Soal membaca di mana peserta dapat memilih lebih dari satu jawaban yang benar.",
			"Multiple Choice, Multiple Answers (Listening)": "Soal menyimak di mana peserta dapat memilih lebih dari satu jawaban yang benar.",
			"Summarize Spoken Text": "Tugas menyimak di mana peserta menulis rangkuman dari apa yang didengar.",
			"Highlight Correct Summary": "Tugas menyimak di mana peserta menandai rangkuman yang paling sesuai dengan audio.",
			"Select Missing Word": "Tugas menyimak bergaya isian di mana peserta memilih kata yang hilang.",
			"Highlight Incorrect Words": "Tugas menyimak di mana peserta menandai kata-kata dalam transkrip yang berbeda dari audio.",
			"Write from Dictation": "Tugas menyimak di mana peserta menuliskan kalimat yang didengar."
		}
	},
	"report": {
		"readFullInsights": "Baca wawasan lengkap",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Dimulai pada {{time}}",
		"itemTypesTitle": "Perincian jenis item",
		"itemTypesFilterAll": "Semua",
		"questionTypeCardTitle": "Perincian jenis item {{skill}}",
		"questionTypeCardSubtitle_one": "Berdasarkan {{count}} jenis soal {{skill}} dalam sesi ini",
		"questionTypeCardSubtitle_other": "Berdasarkan {{count}} jenis soal {{skill}} dalam sesi ini",
		"questionTypeCardAltSubtitle_one": "{{count}} jenis",
		"questionTypeCardAltSubtitle_other": "{{count}} jenis",
		"questionTypeRowSubtitle_zero": "Tidak ada item yang dijawab",
		"questionTypeRowSubtitle_one": "{{count}} item dijawab",
		"questionTypeRowSubtitle_other": "{{count}} item dijawab",
		"itemTypeDetail": {
			"review_one": "Tinjau item",
			"review_other": "Tinjau item",
			"stats": {
				"answered_one": "Item dijawab",
				"answered_other": "Item dijawab",
				"avgTime": "Waktu rata-rata per item"
			}
		},
		"reviewAnswersDialog": {
			"title": "Tinjau Jawaban",
			"sections": {
				"skills": "Keterampilan",
				"questionTypes": "Jenis soal",
				"proficiency": "Kemahiran",
				"performance": "Performa"
			},
			"summaryNone": "Pilih filter yang memiliki item untuk melanjutkan.",
			"summaryAll_one": "Tinjau semua {{count}} jawaban.",
			"summaryAll_other": "Tinjau semua {{count}} jawaban.",
			"summaryFiltered_one": "Tinjau {{count}} jawaban yang cocok dengan {{filters}}.",
			"summaryFiltered_other": "Tinjau {{count}} jawaban yang cocok dengan {{filters}}.",
			"reviewAnswers_one": "Tinjau {{count}} jawaban",
			"reviewAnswers_other": "Tinjau {{count}} jawaban",
			"more": "{{count}} lainnya"
		},
		"itemDetail": {
			"title": "Tinjau jawaban saya",
			"filterAll": "Semua",
			"filterCorrect": "Benar",
			"filterIncorrect": "Salah",
			"filterMarked": "Ditandai",
			"emptyTitle": "Tidak ada item yang cocok",
			"emptyDescription": "Tidak ada item sesi yang cocok dengan filter pilihan ({{filter}}). Sesuaikan atau hapus filter untuk melihat hasil lainnya.",
			"emptyCta": "Hapus filter"
		},
		"answerCardTitle": "Tinjauan item",
		"answerCardSubtitle_one": "Berdasarkan {{count}} item",
		"answerCardSubtitle_other": "Berdasarkan {{count}} item",
		"skillsBreakdown": {
			"title": "Perincian Keterampilan",
			"subtitle_one": "Berdasarkan {{count}} item",
			"subtitle_other": "Berdasarkan {{count}} item"
		},
		"studyPack": "Paket Belajar",
		"practiceTestCompleted": "Tes latihan selesai",
		"studySessionCompleted": "Sesi belajar selesai",
		"diagnosticSessionCompleted": "Sesi diagnostik selesai",
		"timeElapsed": "Waktu berlalu",
		"stats": {
			"answered": "DIJAWAB",
			"time elapsed": "WAKTU BERLALU",
			"avg speed": "KECEPATAN RATA-RATA",
			"hints used": "PETUNJUK DIGUNAKAN"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Luar biasa—teruslah berusaha mencapai yang terbaik!",
				"highIntermediate": "Anda hebat—terus asah keunggulan Anda!",
				"lowIntermediate": "Kemajuan Anda stabil—pertahankan!",
				"basic": "Teruslah berlatih untuk meningkatkan kemampuan Anda!"
			},
			"infoText": "Anda menyelesaikan **{{numActivities}} {{activityLabel}}** untuk melatih {{skillsText}} {{skills}} Anda. {{skillDetails}}. Secara keseluruhan, Anda memperoleh **{{numPointsEarned}} dari {{numTotalPoints}} poin**, yang menunjukkan kemahiran tingkat **{{compositeLevel}}** pada {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Anda menyelesaikan **{{itemCount}} {{itemLabel}}** yang berfokus pada keterampilan **{{skill_1}}**. Anda memperoleh skor **{{skill_1_score}} dari {{skill_1_total}}**, yang menunjukkan kemahiran tingkat **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Anda menyelesaikan **{{itemCount}} {{itemLabel}}** untuk melatih keterampilan **{{skills_text}}**. {{skill_details}} Secara keseluruhan, Anda memperoleh **{{overall_score}} dari {{overall_total}} poin**, yang menunjukkan kemahiran tingkat **{{overall_proficiency}}** pada keterampilan ini. {{compositeFeedback}}",
			"skillDetails": "Dalam **{{skill}}**, Anda memperoleh skor **{{score}} dari {{total}}**, yang menunjukkan kemahiran tingkat **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Ke beranda",
			"studyMore": "Belajar lagi",
			"studyFree": "Belajar gratis {{tagTypes}}",
			"reviewAnswers": "Tinjau jawaban"
		},
		"nextAction": {
			"title": "Disarankan: latihan {{focus}}",
			"dialog": {
				"title": "Sesi belajar yang disarankan",
				"subtitle": "Fokus pada area yang perlu ditingkatkan"
			},
			"fallback": {
				"title": "Terus berlatih",
				"description": "Buat sesi belajar berdasarkan area yang ingin Anda pelajari berikutnya."
			}
		},
		"premium": {
			"upgradeCta": "Tingkatkan ke premium"
		},
		"disclaimer": {
			"title": "Penafian",
			"summativeBody": "Skor tes latihan merupakan perkiraan dan tidak menjamin hasil yang sama pada tes {{examName}} sebenarnya. Skor aktual dapat berbeda tergantung pada kondisi tes dan penilaian resmi."
		},
		"performance": {
			"title": "Performa",
			"subtitle": "Berdasarkan {{count}} item",
			"correct": "Benar",
			"correctItems": "{{count}} item",
			"incorrect": "Salah",
			"incorrectItems": "{{count}} item"
		},
		"mastery": {
			"performanceTitle": "Performa",
			"sessionMasteryTitle": "Perkiraan kemahiran",
			"subtitle_assessment": "Berdasarkan seluruh {{count}} {{item}} dari asesmen ini",
			"subtitle_session": "Berdasarkan seluruh {{count}} {{item}} dari sesi ini"
		},
		"sessionAnalysis": {
			"title": "Analisis sesi",
			"subtitle": "Analisis dan rekomendasi yang dipersonalisasi",
			"viewFullAnalysis": "Lihat analisis",
			"feedbackDialog": {
				"body": "Kami merilis pembaruan hampir setiap hari dan bertekad untuk terus menyempurnakan layanan. Bersediakah Anda memberikan umpan balik?",
				"placeholder": "Masukkan umpan balik Anda di sini",
				"cta": "Kirim umpan balik",
				"successMessage": "Umpan balik terkirim. Terima kasih!",
				"feedbackLimitError": "Umpan balik harus terdiri dari minimal 10 karakter"
			},
			"menuActions": {
				"copy": "Salin",
				"altCopy": "Salin teks ringkasan",
				"altPositiveFeedback": "Ini membantu",
				"positiveFeedback": "Tanggapan baik",
				"negativeFeedback": "Tanggapan buruk",
				"reportIssue": "Laporkan",
				"altReportIssue": "Laporkan tanggapan ini",
				"emailSummary": "Kirim teks ringkasan melalui email",
				"emailAlreadySent": "Email sudah dikirim",
				"copiedAnalysis": "Analisis disalin ke papan klip",
				"emailSent": "Email dikirim ke {{email}}. Jika tidak menerima email, periksa folder sampah, spam, dan baru saja dihapus",
				"emailFailed": "Gagal mengirim email ke {{email}}",
				"emailInstructionMessage": "Jika tidak menerima email, periksa folder sampah, spam, dan baru saja dihapus, atau hubungi administrator TI Anda"
			}
		}
	},
	"feedback": {
		"successMessage": "Masukan berhasil dikirim. Terima kasih!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Apa yang Anda sukai? Apa yang dapat ditingkatkan? Kami melakukan peningkatan pada platform setiap hari dan tim kami membaca setiap masukan. Terima kasih!",
			"title": "Bagikan masukan Anda",
			"body": "Apa yang Anda sukai? Apa yang dapat ditingkatkan? Kami melakukan peningkatan pada platform setiap hari dan tim kami membaca setiap masukan. **Terima kasih!**",
			"positiveBody": "Kami senang ini bermanfaat! Beri tahu kami **apa yang Anda sukai.**",
			"negativeBody": "Bantu kami memahami masalah yang terjadi agar kami dapat **meningkatkan respons kami.**",
			"placeholder": "Masukkan masukan",
			"cta": "Kirim masukan"
		},
		"report": {
			"title": "Kirim laporan",
			"body": "Bantu kami memahami masalah pada respons ini",
			"cta": "Kirim laporan"
		},
		"suggestCorrection": {
			"title": "Sarankan koreksi",
			"body": "Bantu kami meningkatkan keakuratan konten ini dengan **melaporkan kesalahan.**",
			"cta": "Kirim"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Tidak akurat",
					"description": "Respons berisi informasi yang tidak benar"
				},
				"notHelpful": {
					"title": "Tidak membantu",
					"description": "Respons tidak menjawab pertanyaan saya"
				},
				"incomplete": {
					"title": "Tidak lengkap",
					"description": "Respons tidak mencantumkan detail penting"
				},
				"hardToUnderstand": {
					"title": "Sulit dipahami",
					"description": "Respons membingungkan atau tidak jelas"
				},
				"other": {
					"title": "Lainnya",
					"description": "Alasan lainnya"
				}
			},
			"report": {
				"misinformation": {
					"title": "Informasi keliru",
					"description": "Respons berisi informasi palsu atau menyesatkan"
				},
				"harmfulContent": {
					"title": "Konten Berbahaya atau Menyinggung",
					"description": "Ujaran kebencian, pelecehan, atau bahasa yang tidak pantas"
				},
				"violatesPolicies": {
					"title": "Melanggar Kebijakan",
					"description": "Spam, promosi diri, atau konten ilegal"
				},
				"other": {
					"title": "Lainnya",
					"description": "Jelaskan masalah yang terjadi dengan kata-kata Anda sendiri"
				}
			}
		},
		"faqs": {
			"title": "Pertanyaan umum",
			"body": "Berikut beberapa pertanyaan yang paling sering diajukan tentang aplikasi. Jika Anda memiliki pertanyaan lain, silakan hubungi kami di support@memorang.ai"
		},
		"delete": {
			"title": "Hapus akun",
			"body": "Kami turut sedih melihat Anda pergi dan semoga Anda sukses dalam perjalanan akademis dan profesional Anda!",
			"options": "Terlalu mahal|Saya sudah mengikuti ujian|Saya tidak menyukai kontennya|Fitur/fungsionalitas tidak tersedia|Lainnya",
			"confirmdelete": {
				"title": "Konfirmasi Penghapusan Akun",
				"cta": "Hapus",
				"errorMessage": "Maaf, email tersebut tidak cocok dengan akun ini. Silakan coba lagi",
				"successMessage": "Akun berhasil dihapus!",
				"validEmail": "Masukkan alamat email yang valid"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Ketuk untuk merekam respons Anda",
		"responseAudioUnavailable": "Audio jawaban tidak tersedia untuk diputar",
		"recording": "Merekam",
		"recordingCompleted": "Perekaman Selesai",
		"getReady": "Bersiaplah",
		"timeIsUp": "Waktu habis. Respons Anda tidak direkam.",
		"alert": {
			"title": "Durasi maksimum tercapai",
			"body": "Perekaman dihentikan karena telah mencapai durasi maksimum {{maxDuration}} detik."
		},
		"uiElementPressed": "Perekaman dihentikan—stimulus dibuka saat perekaman sedang berlangsung."
	},
	"writing": {
		"placeholder": "Tulis respons Anda di sini...",
		"wordCount": "{{count}} {{word}}",
		"title": "Respons Anda",
		"submit": "Kirim",
		"helper": {
			"range": "Tulis {{min}}–{{max}} kata untuk mengirim respons Anda",
			"min": "Tulis setidaknya {{min}} kata untuk mengirim respons Anda",
			"max": "Persingkat respons Anda menjadi {{max}} kata atau kurang"
		}
	},
	"navbar": {
		"home": "Beranda",
		"progress": "Progres",
		"insights": "Wawasan",
		"leaderboard": "Peringkat",
		"store": "Toko",
		"more": "Lainnya",
		"redeem": "Tukarkan",
		"study-pack": "Paket Belajar",
		"podcasts": "Podcast",
		"modules": "Modul",
		"account": "Pengaturan akun",
		"accountTab": "Akun",
		"privacy": "Privasi",
		"terms": "Ketentuan",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Sudah memasukkan kode dengan benar tetapi masih bermasalah? **Hubungi dukungan** dan pastikan menyertakan kode akses serta detail pembelian Anda",
		"olxDialog": {
			"unlockedTitle": "Akses Terbuka",
			"expiredTitle": "Akses Berakhir",
			"testInfo": "**Ujian:** {{examName}} | **Tes:** {{bundleName}}",
			"upcomingBody_one": "Akses Anda ke tes OLX telah dibuka!\n\nAnda dapat memulai sesi dalam **{{count}} hari**. Silakan periksa kembali nanti untuk memulai sesi Anda dari tab Tes Latihan.",
			"upcomingBody_other": "Akses Anda ke tes OLX telah dibuka!\n\nAnda dapat memulai sesi dalam **{{count}} hari**. Silakan periksa kembali nanti untuk memulai sesi Anda dari tab Tes Latihan.",
			"activeBody": "Akses Anda ke tes OLX kini aktif!\n\nAnda dapat memulai sesi kapan saja sebelum **{{date}}**.\n\nApakah Anda ingin memulai sesi sekarang atau nanti?",
			"expiredBody": "Akses Anda ke tes OLX telah berakhir pada **{{date}}**.\n\nSilakan hubungi profesor atau administrator sekolah Anda untuk bantuan lebih lanjut.",
			"startNowCta": "Mulai Sekarang",
			"startLaterCta": "Mulai Nanti"
		},
		"unexpectedError": "Terjadi kesalahan yang tidak terduga."
	},
	"redeemCode": {
		"titleRedeem": "Tukarkan Akses",
		"titleGranted": "Akses Diberikan",
		"formTitle": "Masukkan kode akses Anda",
		"accessCodeHint": "Jika Anda memiliki kode akses, masukkan di sini, termasuk tanda hubung.",
		"submit": "Kirim",
		"access": "Akses di sini",
		"helpFindCode": "Perlu bantuan menemukan kode akses Anda?",
		"troubleRedeeming": "Kesulitan menukarkan kode? Tanyakan kepada Asisten!",
		"skipStep": "Lewati langkah ini"
	},
	"autoRedeem": {
		"redeem": "Tukarkan",
		"redeeming": "Menukarkan...",
		"continue": "Lanjutkan",
		"unredeemedPrompt_one": "Ada **{{count}} langganan** yang terkait dengan alamat email **{{email}}** dan belum ditukarkan. Apakah Anda ingin menambahkannya ke akun Anda?",
		"unredeemedPrompt_other": "Ada **{{count}} langganan** yang terkait dengan alamat email **{{email}}** dan belum ditukarkan. Apakah Anda ingin menambahkannya ke akun Anda?",
		"successMessage_one": "Selamat! **Produk** di bawah ini telah dibuka di akun Anda. Setelah menekan lanjutkan, konteks aplikasi Anda akan diubah untuk menampilkan ujian: **{{examName}}**. Anda dapat mengubahnya kapan saja melalui pengaturan akun jika ingin belajar untuk ujian lain atau membeli langganan lain.",
		"successMessage_other": "Selamat! **{{count}} produk** di bawah ini telah dibuka di akun Anda. Setelah menekan lanjutkan, konteks aplikasi Anda akan diubah untuk menampilkan ujian: **{{examName}}**. Anda dapat mengubahnya kapan saja melalui pengaturan akun jika ingin belajar untuk ujian lain atau membeli langganan lain."
	},
	"olxEligibility": {
		"goToPracticeTests": "Buka tes latihan"
	},
	"moreChallenges": {
		"challenges": "Tantangan",
		"challengesCount": "{{value}} Tantangan"
	},
	"tts": {
		"tooltip": "Dengarkan"
	},
	"commandBar": {
		"placeholder": "Cari...",
		"input": {
			"placeholder": "Ketik perintah atau cari"
		},
		"sections": {
			"quickActions": "Tindakan cepat"
		},
		"actions": {
			"changeExam": "Ganti ujian",
			"switchToDarkMode": "Ganti ke mode gelap",
			"switchToLightMode": "Ganti ke mode terang",
			"setExamDate": "Atur tanggal tes"
		}
	},
	"filterView": {
		"placeholder": "Cari ujian..."
	},
	"transcript": {
		"show": "Tampilkan transkrip",
		"hide": "Sembunyikan transkrip"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logo Aplikasi",
			"testNameLabel": "Nama Tes",
			"sectionLabel": "Bagian",
			"back": "Kembali",
			"pause": "Jeda",
			"menuLabel": "Opsi lainnya"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Progres tes",
			"of": "dari",
			"pauseSession": "Jeda Sesi",
			"timerTooltip": {
				"item": "Waktu tersisa untuk pertanyaan ini",
				"section": "Waktu tersisa di bagian ini",
				"test": "Waktu tersisa dalam tes ini"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Berikutnya"
		},
		"progressBar": {
			"timeLeftLabel": "Waktu tersisa untuk pertanyaan ini",
			"timeLeftForUnit": "Waktu tersisa untuk unit ini",
			"questionOf": "Pertanyaan {{current}} dari {{total}}",
			"questionProgress": "<b>{{current}}</b> dari {{total}}",
			"timesUp": "Waktu habis",
			"statusTooltips": {
				"answered": "Dijawab",
				"inProgress": "Sedang Dikerjakan",
				"skipped": "Dilewati",
				"notSeen": "Belum Dilihat"
			}
		},
		"timeRemainingDialog": {
			"title": "Anda masih memiliki waktu",
			"body": "Masih ada waktu tersisa untuk unit ini. Apakah Anda ingin meninjau jawaban sebelum mengirimkannya?",
			"reviewCta": "Tinjau jawaban saya"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Sumber",
				"answerTitle": "Jawaban Anda",
				"remainingBadge": "{{count}} tersisa",
				"placedBadge": "{{count}} ditempatkan",
				"pointsBadge": "{{earned}}/{{max}} poin",
				"emptyHint": "Seret paragraf ke sini dari panel kiri"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Informasi Dukungan",
			"emailLabel": "Email",
			"subjectLabel": "Subjek",
			"messageBodyLabel": "Isi Pesan",
			"appDetailsLabel": "Detail Aplikasi",
			"appNameLabel": "Nama",
			"versionLabel": "Versi",
			"platformLabel": "Platform"
		},
		"chat": {
			"assistantTitle": "Asisten Dukungan {{tenantName}}",
			"fallbackTitle": "Obrolan",
			"betaWarning": "Asisten AI ini masih dalam tahap **Beta**—respons mungkin sesekali tidak akurat atau tidak lengkap.",
			"greeting": "Hai 👋 Apakah Anda kesulitan mendapatkan akses ke suatu produk? Saya di sini untuk membantu! Pertama, mari kita persempit masalahnya. Mana dari situasi berikut yang paling menggambarkan kondisi Anda?\n\n1. Saya memiliki kode akses, tetapi sepertinya tidak berfungsi.\n2. Saya sudah melakukan pembelian, tetapi tidak dapat menemukan kode akses saya.\n3. Seharusnya saya diberi akses melalui sekolah saya, tetapi tidak dapat menemukan kode akses saya.\n4. Sebelumnya saya memiliki akses ke suatu produk, tetapi sekarang tidak dapat mengaksesnya.\n\nSilakan masukkan nomor yang sesuai dengan masalah Anda.",
			"input": {
				"label": "Ketik pesan...",
				"sendLabel": "Kirim"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Berhasil Ditukarkan",
			"previouslyRedeemedTitle": "🚀 Sudah Pernah Ditukarkan",
			"subtitle": "Akses konten Anda di sini",
			"expires": "Berakhir: {{date}}",
			"openCta": "Buka"
		},
		"purchases": {
			"title": "🎉 Kode Akses Ditemukan",
			"subtitle": "Tukarkan untuk mendapatkan akses ke konten Anda",
			"accessCodesLabel_one": "Kode Akses",
			"accessCodesLabel_other": "Kode Akses",
			"moreCodes_one": "(+ {{count}} lagi)",
			"moreCodes_other": "(+ {{count}} lagi)",
			"featuresLabel": "Fitur",
			"redeemCta": "Tukarkan"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Versi baru tersedia, klik segarkan untuk memperbarui.",
			"refreshCta": "Segarkan",
			"refreshA11yLabel": "Segarkan untuk memperbarui aplikasi",
			"dismissTooltip": "Tutup",
			"dismissA11yLabel": "Tutup notifikasi pembaruan"
		}
	},
	"cme": {
		"type": "Jenis CME",
		"chooseExportMethod": "Pilih metode ekspor",
		"selectDateRange": "Pilih rentang tanggal",
		"from": "Dari",
		"to": "Hingga",
		"sendPdfTo": "Kirim PDF ke {{email}}",
		"downloadCertificate": "Unduh Sertifikat ke PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Kredit CME yang Diperoleh",
		"confirmYourName": "Konfirmasi nama Anda",
		"certificateNameNotice": "Nama ini akan dicetak pada Sertifikat CME Anda.",
		"firstName": "Nama depan",
		"lastName": "Nama belakang",
		"firstNamePlaceholder": "Masukkan nama depan Anda",
		"lastNamePlaceholder": "Masukkan nama belakang Anda",
		"confirm": "Konfirmasi",
		"creditsEarnedTitle": "CME yang Diperoleh",
		"creditRatioCaption": "12 Tantangan = 1 Kredit CME",
		"earned": "Diperoleh",
		"available": "Tersedia",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Ekspor Sertifikat CME",
		"exportDisabledCaption": "Anda perlu mendapatkan setidaknya 1 kredit CME untuk mengekspor sertifikat Anda",
		"viewDisclaimer": "Lihat penafian CME"
	}
}
